import React, { useState } from "react";
import { Form, InputGroup, Modal, Button } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Close_Trade_Modal.css";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import Success_Lottie from "../../../animation/success_lottie/Success_Lottie";
import Close_modal from "../close_modal/Close_modal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Close_Trade_Modal = (props) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modalCloseShow, setModalCloseShow] = useState(false);
  const [error, setError] = useState("");
  const [closeQuantity, setCloseQuantity] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setError("");
    
    if (!closeQuantity.trim()) {
      setError("Please enter quantity");
      toast.error("Please enter quantity", { position: "bottom-right" });
      return;
    }

    const qty = Number(closeQuantity);

    if (isNaN(qty) || qty <= 0) {
      setError("Quantity must be greater than 0");
      toast.error("Quantity must be greater than 0", { position: "bottom-right" });
      return;
    }

    if (qty > Number(props?.quantity || 0)) {
      setError("Quantity cannot be greater than available quantity");
      toast.error("Quantity exceeds available amount", { position: "bottom-right" });
      return;
    }

    setModalCloseShow(true);
  };

  return (
    <>
      <ToastContainer position="bottom-right" theme="dark" />

      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="close-trade-modal premium-modal max-md:scale-[.80]"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header 
          closeButton 
          className="border-b border-cyan-900/40 bg-gradient-to-r from-slate-950 to-slate-900/95 backdrop-blur-lg"
          closeVariant="white"
        >
          <Modal.Title 
            id="contained-modal-title-vcenter"
            className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-cyan-300 to-blue-500 tracking-tight"
          >
            Close Trade
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-gradient-to-b from-slate-950/95 to-black/95 backdrop-blur-2xl p-8 md:p-10">
          <div className="space-y-8 max-w-lg mx-auto">
            {/* Available Quantity */}
            <div className="inline-flex items-center gap-4 px-6 py-4 rounded-2xl bg-slate-900/70 border border-cyan-800/50 backdrop-blur-md shadow-inner mx-auto">
              <span className="text-cyan-300 font-medium text-lg">Available:</span>
              <span className="text-3xl font-bold text-white drop-shadow-md">
                {props?.quantity || 0}
              </span>
              <span className="text-xl font-semibold text-cyan-200">lot(s)</span>
            </div>

            {/* Quantity Input with Floating Label */}
            <div className="form-group relative">
              <Form.Label 
                className={`floating-label absolute left-5 transition-all duration-300 pointer-events-none text-cyan-400/80 
                  ${closeQuantity ? '!hidden text-sm  px-2' : '-top-5 text-base'}`}
              >
                Quantity to Close
              </Form.Label>

              <Form.Control
                type="number"
                placeholder=" "
                value={closeQuantity}
                min="0.01"
                step="0.01"
                className={`modern-input w-full text-black bg-slate-900/70 border-2 border-cyan-900/50 rounded-2xl py-6 px-3 text-xl font-medium focus:border-cyan-400 focus:ring-cyan-500/30 transition-all ${error ? 'border-red-500/70 focus:border-red-500' : ''}`}
                onChange={(e) => {
                  setCloseQuantity(e.target.value);
                  setError("");
                }}
                disabled={isSubmitting}
              />
            </div>

            {/* Error Message */}
            {error && (
              <div className="flex items-center gap-3 text-red-400 text-sm font-medium bg-red-950/30 border border-red-900/50 rounded-xl px-5 py-3">
                <FontAwesomeIcon icon={faXmark} className="text-red-500 text-lg" />
                {error}
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-5 justify-center pt-6">
              <Button
                variant="outline-light"
                className="min-w-[160px] px-8 py-4 rounded-2xl border-2 border-cyan-800/60 text-cyan-300 hover:bg-cyan-950/50 hover:border-cyan-400 hover:text-cyan-200 transition-all duration-300 shadow-sm hover:shadow-cyan-500/30 text-lg font-medium"
                onClick={() => props.onHide()}
                disabled={isSubmitting}
              >
                Cancel
              </Button>

              <Orange_White_Border_Btn
                btn_name={isSubmitting ? "Processing..." : "Proceed to Close"}
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="min-w-[220px] py-4 text-lg font-semibold rounded-2xl shadow-lg hover:shadow-orange-500/40 transition-all"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Close_modal
        getGraphData={props.getGraphData}
        show={modalCloseShow}
        closeTradeId={props?.closeTradeId}
        amount={props?.amount}
        closeQuantity={closeQuantity}
        onHide={() => setModalCloseShow(false)}
        onClose={() => props?.onHide(false)}
        latestAmount={props?.latestAmount}
      />

      {/* <Successfull_Modal ... /> */} {/* Keep commented if not needed */}
    </>
  );
};

export default Close_Trade_Modal;